import "babel-polyfill";
import { binder } from "./libs/binder";
import { tabbedPage } from "./modules/tabbedPage";
import { gforms } from "./modules/gforms";
import { lazyLoadingImages } from "./modules/lazy-loading-images"

binder({
    bounds: {
        '.page-template-tabbed': tabbedPage,
        '.questionnaire-popup-launcher': gforms,
        ".bg-load": lazyLoadingImages
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js